import React from "react";
import { FaRegEnvelope, FaPhone, FaRegTrashAlt } from "react-icons/fa";
import bookimg from "../../../../../../images/all/2.jpg";
import "./Book.css";

const Book = () => {
  return (
    <div className="book-container">
      <div className="book-grid">
        <div className="book-head">
          <img src={bookimg} alt="" className="book-img" />
          <h3>
            For <span className="book-span1">Gorgeous house for sale</span>
          </h3>
        </div>
        <div className="book-mid">
          <div className="mid-inner">
            <span className="mid-inner-flex">
              <h5>Name:</h5>
              <p >Andy Smith</p>
            </span>
            <span className="mid-inner-flex">
              <h5>Phone:</h5>
              <p>+7(123)987654</p>
            </span>
            <span className="mid-inner-flex">
              <h5>Date:</h5>
              <p>18.05.2021</p>
            </span>
            <span className="mid-inner-flex">
              <h5>Time:</h5>
              <p>12 AM</p>
            </span>
          </div>
          <p className="mid-p">
            Morbi varius, nulla sit amet rutrum elementum, est elit finibus
            tellus, ut tristique elit risus at metus. Lorem ipsum dolor sit
            amet, consectetur adipiscing elit.
          </p>
          <div className="book-foot">
            <div className="book-foot-flex1">
              <p>12 December 2020</p>
            </div>
            <div className="book-foot-flex2">
              <FaRegEnvelope className="book-icon" />
              <FaPhone className="book-icon" />
              <FaRegTrashAlt className="book-icon" />
            </div>
          </div>
        </div>
      </div>
      <div className="book-grid">
        <div className="book-head">
          <img src={bookimg} alt="" className="book-img" />
          <h3>
            For <span className="book-span1">Gorgeous house for sale</span>
          </h3>
        </div>
        <div className="book-mid">
          <div className="mid-inner">
            <span className="mid-inner-flex">
              <h5>Name:</h5>
              <p >Andy Smith</p>
            </span>
            <span className="mid-inner-flex">
              <h5>Phone:</h5>
              <p>+7(123)987654</p>
            </span>
            <span className="mid-inner-flex">
              <h5>Date:</h5>
              <p>18.05.2021</p>
            </span>
            <span className="mid-inner-flex">
              <h5>Time:</h5>
              <p>12 AM</p>
            </span>
          </div>
          <p className="mid-p">
            Morbi varius, nulla sit amet rutrum elementum, est elit finibus
            tellus, ut tristique elit risus at metus. Lorem ipsum dolor sit
            amet, consectetur adipiscing elit.
          </p>
          <div className="book-foot">
            <div className="book-foot-flex1">
              <p>12 December 2020</p>
            </div>
            <div className="book-foot-flex2">
              <FaRegEnvelope className="book-icon" />
              <FaPhone className="book-icon" />
              <FaRegTrashAlt className="book-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;
